module.exports = __webpack_public_path__ + "img/10.2656386a.jpeg";